<template>
    <div class="fs layer0" ref="mc"></div>
    <div v-if="isUserActionRequired" id="startScreen"><button @click="Entry()">START AR</button></div>
</template>

<script>
    import * as THREE from 'three';
    import * as AR_Renderer from "@/AR-Renderer/ar_renderer";


    export default {
        name: 'MarkerScene',
        props: {
            sceneData: Object
        },
        data() {
            return {
                isUserActionRequired: false,

                hitTestSourceRequested: false,
                hitTestSource: null,
                hitMatrix: new THREE.Matrix4(),
            };
        },
        mounted() {
            this.Entry();
        },
        methods: {
            async Entry() {
                this.$parent.ShowLoadingIndicator(true);
                await this.$parent.SetCurrentScene(this);
                this.Launch();
            },

            async Launch() {
                await this.Setup();
                await this.Start();
                return;
            },

            async Setup() {
                this.scene = new THREE.Scene();
                this.camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.01, 20);

                this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
                this.renderer.setPixelRatio(window.devicePixelRatio);
                this.renderer.setSize(window.innerWidth, window.innerHeight);
                this.renderer.xr.enabled = true;

                this.$refs.mc.appendChild(this.renderer.domElement);

                this.controller = this.renderer.xr.getController(0);
                this.scene.add(this.controller);

                this.Start = async () => {
                    navigator.xr.requestSession('immersive-ar', {
                        optionalFeatures: [
                            "dom-overlay"
                        ],
                        requiredFeatures: [
                            "hit-test",
                        ],
                        domOverlay: {
                            root: this.sceneData.unity
                        }
                    }).then(async (session) => {
                        this.isUserActionRequired = false;
                        this.session = session;
                        this.renderer.xr.setReferenceSpaceType('local');
                        await this.renderer.xr.setSession(session);

                        this.$parent.ShowLoadingIndicator(false);
                        AR_Renderer.onSceneLoaded(this.sceneData.sceneIndex);

                        this.animate();
                        return;
                    }).catch(() => {
                        this.$parent.ShowLoadingIndicator(false);
                        this.isUserActionRequired = true;
                    });
                }

                this.Stop = async () => {
                    if (this.session) {
                        await this.session.end();
                        return;
                    }
                    return;
                }
            },
            animate() {
                this.renderer.setAnimationLoop((timestamp, frame) => {
                    this.Render(timestamp, frame);
                    this.SendCameraTransformTounity();
                });
            },

            Render(timestamp, frame) {
                if (frame) {
                    const referenceSpace = this.renderer.xr.getReferenceSpace();
                    const session = this.renderer.xr.getSession();
                    
                    if (this.hitTestSourceRequested === false) {
                        let t = this;
                        session.requestReferenceSpace('viewer').then(function (referenceSpace) {
                            session.requestHitTestSource({ space: referenceSpace }).then(function (source) {

                                t.hitTestSource = source;
                            });
                        });

                        session.addEventListener('end', function () {
                            this.hitTestSourceRequested = false;
                            this.hitTestSource = null;
                        });
                        this.hitTestSourceRequested = true;
                    }

                    if (this.hitTestSource) {
                        const hitTestResults = frame.getHitTestResults(this.hitTestSource);
                        if (hitTestResults.length) {
                            const hit = hitTestResults[0];
                            this.hitMatrix = new THREE.Matrix4().fromArray(hit.getPose(referenceSpace).transform.matrix);
                        } else {
                            this.hitMatrix = new THREE.Matrix4();
                        }
                    }
                }
                this.renderer.render(this.scene, this.camera);
            },

            SendCameraTransformTounity() {
                let matrix = this.camera.matrixWorld.elements;
                let fov = this.camera.fov;

                let hitPosition = new THREE.Vector3().setFromMatrixPosition(this.hitMatrix);
                let cameraPosition = new THREE.Vector3().setFromMatrixPosition(this.camera.matrixWorld);

                const direction = new THREE.Vector3();
                direction.subVectors(hitPosition, cameraPosition);

                AR_Renderer.onMarkerTracking(matrix, direction.length(), fov);
            }
        }
    }
</script>

<style scoped>
    @import '../css/styles.css';


    #startScreen {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        backdrop-filter: blur(10px);
        justify-content:flex-end;
        align-items: center;
        flex-direction: column;
        padding: 50px;
        display: flex;
        z-index: 1;
    }

        #startScreen button {
            padding: 10px;
            background-color: transparent;
            border-radius: 10px;
            font-size: 14px;
            color: darkgrey;
            font-weight: bold;
            border: 1px solid darkgrey;
        }

            #startScreen button:active {
                color: lightgrey;
                border: 2px solid lightgrey;
            }
</style>
